import React from "react";
import './Button.css'

function Button
    (
        {
            key,
            clickMethod,
            buttonName,
            disabled,
            style,
            type,
            className,
            title
        }
    ) {

    // Várias telas fixam `height` inline; como piso (minHeight) o botão
    // cresce quando o rótulo precisa de duas linhas, sem vazar da caixa.
    let buttonStyle = style;
    if (style && typeof style.height === 'string' && style.height.endsWith('px')) {
        const { height, ...rest } = style;
        buttonStyle = { ...rest, minHeight: style.minHeight || height };
    }

    return (
        <button
            key={key}
            className={className ? `button-field ${className}` : 'button-field'}
            onClick={() => { clickMethod() }}
            disabled={disabled}
            style={buttonStyle}
            type={type}
            title={title}
        >
            {buttonName}
        </button>
    );
}

export default Button;
